import {useState} from "react";

import {Button} from "@pg-design/button-module";

import {HomeMatchPreferencesWizardSmsDescription} from "@/features/home_match/components/home_match_preferences_wizard/HomeMatchPreferencesWizardSmsDescription";
import {HomeMatchPreferencesWizardSmsStep} from "@/features/home_match/components/home_match_preferences_wizard/HomeMatchPreferencesWizardSmsStep";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "@/features/home_match/constants/preferences/home_match_preferences_wizard_content";
import {useRegisteredSubmit} from "@/hooks/use_registered_submit";

import {UserFlowModal} from "./UserFlowModal";

const {SMS} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IProps {
    isOpen: boolean;
    onChangeNumber: () => void;
    onClose: () => void;
    onSuccess: () => void;
    phone?: string;
    progress?: number;
}

export const UserPhoneSmsModal = (props: IProps) => {
    const {isOpen, onChangeNumber, onClose, onSuccess, phone, progress = 100} = props;
    const [canConfirm, setCanConfirm] = useState(false);
    const [isContentMounted, setIsContentMounted] = useState(isOpen);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {registerSubmit, submit} = useRegisteredSubmit();

    if (isOpen && !isContentMounted) {
        setIsContentMounted(true);
    }

    return (
        <UserFlowModal
            actionsAlign="center"
            description={<HomeMatchPreferencesWizardSmsDescription isSubmitting={isSubmitting} onChangeNumber={onChangeNumber} phone={phone ?? ""} />}
            footer={
                <Button
                    disabled={!canConfirm || isSubmitting}
                    fullWidth
                    isLoading={isSubmitting}
                    onClick={submit}
                    size="small"
                    textVariant="button_medium"
                    type="button"
                    variant="filled_secondary"
                >
                    {SMS.CONFIRM}
                </Button>
            }
            isOpen={isOpen}
            onAfterClose={() => setIsContentMounted(false)}
            onClose={onClose}
            progress={progress}
            title={SMS.TITLE}
        >
            {isContentMounted && (
                <HomeMatchPreferencesWizardSmsStep
                    onCanConfirmChange={setCanConfirm}
                    onRegisterSubmit={registerSubmit}
                    onSubmittingChange={setIsSubmitting}
                    onSuccess={onSuccess}
                />
            )}
        </UserFlowModal>
    );
};
import {useState} from "react";

import {Button} from "@pg-design/button-module";

import {HomeMatchPreferencesWizardSmsDescription} from "@/features/home_match/components/home_match_preferences_wizard/HomeMatchPreferencesWizardSmsDescription";
import {HomeMatchPreferencesWizardSmsStep} from "@/features/home_match/components/home_match_preferences_wizard/HomeMatchPreferencesWizardSmsStep";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "@/features/home_match/constants/preferences/home_match_preferences_wizard_content";
import {useRegisteredSubmit} from "@/hooks/use_registered_submit";

import {UserFlowModal} from "./UserFlowModal";

const {SMS} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IProps {
    isOpen: boolean;
    onChangeNumber: () => void;
    onClose: () => void;
    onSuccess: () => void;
    phone?: string;
    progress?: number;
}

export const UserPhoneSmsModal = (props: IProps) => {
    const {isOpen, onChangeNumber, onClose, onSuccess, phone, progress = 100} = props;
    const [canConfirm, setCanConfirm] = useState(false);
    const [isContentMounted, setIsContentMounted] = useState(isOpen);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {registerSubmit, submit} = useRegisteredSubmit();

    if (isOpen && !isContentMounted) {
        setIsContentMounted(true);
    }

    return (
        <UserFlowModal
            actionsAlign="center"
            description={<HomeMatchPreferencesWizardSmsDescription isSubmitting={isSubmitting} onChangeNumber={onChangeNumber} phone={phone ?? ""} />}
            footer={
                <Button
                    disabled={!canConfirm || isSubmitting}
                    fullWidth
                    isLoading={isSubmitting}
                    onClick={submit}
                    size="small"
                    textVariant="button_medium"
                    type="button"
                    variant="filled_secondary"
                >
                    {SMS.CONFIRM}
                </Button>
            }
            isOpen={isOpen}
            onAfterClose={() => setIsContentMounted(false)}
            onClose={onClose}
            progress={progress}
            title={SMS.TITLE}
        >
            {isContentMounted && (
                <HomeMatchPreferencesWizardSmsStep
                    onCanConfirmChange={setCanConfirm}
                    onRegisterSubmit={registerSubmit}
                    onSubmittingChange={setIsSubmitting}
                    onSuccess={onSuccess}
                />
            )}
        </UserFlowModal>
    );
};
